<template>
<div class="chapter">
<div class="inner_page">
<a id="p1"></a><a id="pxiv"></a>
<h1 class="PN">Part One</h1>
<h1 class="chaptertitle parttitle notop">The Long Decline</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c001.vue?4b047fea